import {
	GlobalEmailTemplate,
	GlobalEmailTemplateMetadata,
} from '@models/global-email-templates';

export class GetGlobalEmailTemplates {
	static readonly type = '[Global Email Templates] Get Templates';
}

export class GetGlobalEmailTemplatesSuccess {
	static readonly type = '[Global Email Templates] Get Templates Success';
	constructor(public templates: GlobalEmailTemplateMetadata[]) {}
}

export class GetGlobalEmailTemplatesFailure {
	static readonly type = '[Global Email Templates] Get Templates Failure';
	constructor(public error: string) {}
}

export class SelectGlobalEmailTemplate {
	static readonly type = '[Global Email Templates] Select Template';
	constructor(public templateId: string) {}
}

export class LoadGlobalEmailTemplateVersions {
	static readonly type = '[Global Email Templates] Load Template Version';
	constructor(public templateId: string) {}
}

export class CreateGlobalEmailTemplate {
	static readonly type = '[Global Email Templates] Create Template';
	constructor(
		public template: GlobalEmailTemplateMetadata,
		public afterCreateAction?: (templateId: string) => void,
	) {}
}

export class UpdateGlobalEmailTemplate {
	static readonly type = '[Global Email Templates] Update Template';
	constructor(
		public templateId: string,
		public templateMetadata: Partial<GlobalEmailTemplateMetadata>,
		public templateVersion?: Omit<Partial<GlobalEmailTemplate>, 'id'>,
	) {}
}

export class DeleteGlobalEmailTemplate {
	static readonly type = '[Global Email Templates] Delete Template';
	constructor(public id: string) {}
}
